import { Link } from 'react-router-dom';
import { topics } from '@/mocks/siteData';

export default function TopicSection() {
  return (
    <section className="mx-auto max-w-portal px-4 py-12 md:px-6 md:py-14">
      <div className="text-center">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-700">Topics</span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">主题专题推荐</h2>
        <p className="mt-2 text-sm text-foreground-600">按主题系统学习，构建属于你的黄金投资知识体系</p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={topic.link}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:border-primary-300"
          >
            <div className="h-40 w-full overflow-hidden bg-background-100">
              <img
                src={topic.image}
                alt={topic.title}
                title={`${topic.title} 黄金投资专题`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                  {topic.title}
                </h3>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                  {topic.count}
                </span>
              </div>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-700">
                进入专题
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}